import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps, ReeferProductTempRange, KeyLabelObject, UserData, BookingMasterData, PaymentDetails, NotifyUsers } from 'src/Library/Types';
import { connect } from 'react-redux';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import Form, { FormComponentProps } from 'antd/lib/form';
import InputNumber from 'antd/lib/input-number';
import Radio from 'antd/lib/radio';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import TextArea from 'antd/lib/input/TextArea';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import { INTTRABookingConfirmationModalStyles } from './INTTRABookingConfirmationModalStyles';
import { isValidString, getDateValue, isValidArray, isValidNumber, highlightDiv, uniqArray, stops } from 'src/Library/Helper';
import { arrayToObject, prettifyString } from 'src/utils/utils';
import isEmpty from 'lodash/isEmpty';
import { ContainerList, CargoList } from 'src/components/common/Types/CommonTypes';
import { CargoType } from '../InquiryUtils';
import { useGenericState } from 'src/Library/UseGenericState';
import { fetchAllUsersOfCurrentOrg } from 'src/api/users';
import { renderSelectDropDown, getConditionalBullets } from 'src/Library/Common';
import Protip from '../Booking/Protip';
import { setPrevPagination } from 'src/actions/bookingInquiryActions';
import { bindActionCreators } from 'redux';
import { createInttraBooking, amendInttraBookingRequest, fetchLocation } from 'src/api/booking';
import EditINTTRAShipmentDetailsModal from './EditINTTRAShipmentDetailsModal';
import { BookingData, BookingDetails, BookingOffice, InttraBookingDetails } from './Booking.types';
import { useDebounce } from 'src/hooks/useDebounce';
import uniqBy from 'lodash/uniqBy';
import { SIPartyAddress, StakeHolders } from '../../shipment-execution/SE.Types';
import { getSIPartyAddress } from '../../shipment-execution/SE.utils';
import UploadSINotifyPartiesAddAddress from '../../shipment-execution/SEActions/SETasks/SETaskList/UploadSINotifyPartiesAddAddress';
import { fetchShipmentInstructionsPartiesAddress } from 'src/api/shipmentExecution';
import { Spin } from 'src/Library/AntdLibComponents';
import classNames from 'classnames';
import startCase from 'lodash/startCase';
import Asterisk from 'src/components/common/Asterisk';
import { tokens } from 'src/design-system';

interface IProps extends
  StylesProps<ReturnType<typeof INTTRABookingConfirmationModalStyles>>, FormComponentProps {
  bookingData: BookingData;
  containerList: ContainerList [];
  reeferProductTempRange: ReeferProductTempRange;
  cargoList: CargoList [];
  packingGroups: KeyLabelObject [];
  bookingMasterData: BookingMasterData;
  receiveInttraBookingNoteEmail: boolean;
  userData: UserData;
  handlePrevious: () => void;
  reload: () => void;
  inttraCode: string;
  isBooking: (booking?: boolean) => void;
  bookingId: string;
  isAmend: boolean;
  isCreateNew: boolean;
  productIMOClassCodeMap: KeyLabelObject;
  isRetryInttraRequest: boolean; /* functionality (prefilling and actions) is same as amend
    but additional amend fields and amend api will not be called */
  handleCloseSideDrawer: () => void;
  inttraBookingNotifyPartyTypes,
  handleCloseBookingModal: () => void;
}

interface StateProps {
  paymentDetails: any [];
  notifyUsers: any [];
  usersList: any [];
  isFetchingUsers: boolean;
  isProtipVisible: boolean;
  isLoading: boolean;
  paymentFieldChanged: boolean;
  paymentFieldIndex?: number;
  userFieldChanged?: boolean;
  userFieldIndex?: number;
  isEditShipmentModalVisible: boolean;
  bookingDetails: BookingDetails;
  bookingOffice: BookingOffice [];
  isBookingOfficeLoading: boolean;
  searchTerm: string;
  inttraBookingDetails: InttraBookingDetails;
  partiesInvolved;
  selectedPartyType: string;
  addressList?: SIPartyAddress;
  isAddEditAddressModalVisible?: boolean;
  editAddressData?;
  isFetchingAddress?: boolean;
}

interface Payers {
  Consignee: string [];
  Shipper: string [];
  FF: string [];
}

const INTTRABookingConfirmationModal = (props: IProps): React.ReactElement => {

  const {
    classes,
    bookingData,
    containerList,
    form,
    reeferProductTempRange,
    cargoList,
    packingGroups,
    bookingMasterData,
    receiveInttraBookingNoteEmail,
    userData,
    handlePrevious,
    reload,
    inttraCode,
    isBooking,
    bookingId,
    isAmend,
    isCreateNew,
    productIMOClassCodeMap,
    isRetryInttraRequest,
    handleCloseSideDrawer,
    inttraBookingNotifyPartyTypes,
    handleCloseBookingModal,
  } = props;

  const {
    chargeDetails,
  } = bookingData;

  const stakeHolders = inttraBookingNotifyPartyTypes?.[chargeDetails?.carrierDetails?.id] || {};

  const [state, setState] = useGenericState<StateProps>({
    paymentDetails: bookingData.inttraBookingDetails?.paymentDetails || [{ }],
    notifyUsers: bookingData.inttraBookingDetails?.notifyUsers || [{
      name: userData.name,
      email: userData.email,
    }],
    usersList: [],
    isFetchingUsers: false,
    isProtipVisible: false,
    isLoading: false,
    paymentFieldChanged: false,
    isEditShipmentModalVisible: false,
    bookingDetails: bookingData.bookingDetails,
    inttraBookingDetails: bookingData.inttraBookingDetails,
    bookingOffice: [],
    isBookingOfficeLoading: false,
    searchTerm: '',
    partiesInvolved: isValidArray(bookingData.inttraBookingDetails?.partiesInvolved) ?
      bookingData.inttraBookingDetails?.partiesInvolved :
      [{ }], // add one field by default
    selectedPartyType: '',
  })

  const {
    paymentDetails,
    notifyUsers,
    usersList,
    isFetchingUsers,
    isProtipVisible,
    isLoading,
    paymentFieldChanged,
    paymentFieldIndex,
    isEditShipmentModalVisible,
    bookingDetails,
    userFieldChanged,
    userFieldIndex,
    bookingOffice,
    isBookingOfficeLoading,
    searchTerm,
    inttraBookingDetails,
    partiesInvolved,
    selectedPartyType,
    addressList,
    isAddEditAddressModalVisible,
    editAddressData,
    isFetchingAddress,
  } = state;

  const {
    chargeTypes,
    freightTerms,
    payer,
  } = bookingMasterData;

  const {
    getFieldDecorator,
  } = form;

  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  React.useEffect(
    () => {
      fetchBookingOffice(debouncedSearchTerm);
    },
    [debouncedSearchTerm],
  );

  React.useEffect(() => {
    if (isAmend && !isRetryInttraRequest) {
      highlightDiv(
        document.getElementById('amendmentJustification'),
        'rgba(24,144,255,0.08)',
        5000,
      );
    }
  }, []);

  React.useEffect(() => {
    form.validateFields([
      `paymentDetails[${paymentFieldIndex}].chargeType`,
      `paymentDetails[${paymentFieldIndex}].freightTerms`,
      `paymentDetails[${paymentFieldIndex}].payer`,
      `paymentDetails[${paymentFieldIndex}].name`,
    ], (err, values) => {
      if (err) return;
    });
  }, [paymentFieldChanged])

  React.useEffect(() => {
    form.validateFields([
      `notifyUsers[${userFieldIndex}].name`,
      `notifyUsers[${userFieldIndex}].email`,
    ], (err, values) => {
      if (err) return;
    });
  }, [userFieldChanged])

  const renderBasicShipmentDetail = (label, value) : React.ReactElement => {
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>{label}</Col>
        <Col span={18} className={classes.shipmentValue}>{value}</Col>
      </Row>
    );
  };

  const renderPortDetail = (label, value, haulage = undefined) : React.ReactElement => {
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>{label}</Col>
        <Col span={18} className={classes.shipmentValue}>
          <div>{value}</div>
          {isValidString(haulage) &&
            <div style={{ marginTop: '6px', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
              <span style={{ marginRight: '8px', fontWeight: 'normal' }}>Haulage</span>{haulage}
            </div>
          }
        </Col>
      </Row>
    );
  };

  const renderContainerDetails = (containers) : React.ReactElement => {
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>Container Details</Col>
        <Col span={18} className={classes.shipmentValue}>
          {containers?.map(item => {
            const packageDimension = item?.packageDimension;
            const unit = packageDimension?.unit === 'meter' ? 'm' : packageDimension?.unit;
            const containerType = containerList.find((container) => (
              container.key.type === item.type
            ));
            return (
              <div>
                {item.count} X {item.size} {containerType?.label?.type}
                {isValidNumber(item.weight?.value) &&
                  <span> |&nbsp;{item.weight?.value} {item.weight?.unit}</span>
                }
                {isValidNumber(item.carriageTemperature) &&
                  <span> |&nbsp;{item.carriageTemperature} °C</span>
                }
                {!isEmpty(packageDimension) &&
                  <span>
                    &nbsp;| {packageDimension?.length}{unit} X {packageDimension?.breadth}{unit} X
                    &nbsp;{packageDimension?.height}{unit}
                  </span>
                }
              </div>
            )
          })}
        </Col>
      </Row>
    );
  };

  const renderCargoProduct = (cargo, product) : React.ReactElement => {
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>Cargo &amp; Product</Col>
        <Col span={18} className={classes.shipmentValue}>{cargo} | {product}</Col>
      </Row>
    );
  };

  const renderETALabel = () : React.ReactElement => {
    return (
      <span>
        Estimated Time of Departure
        <Tooltip
          overlayStyle={{ fontSize: `${tokens.fontSize.small}px` }}
          title="Start of sailing date range shared by shipper"
          placement="topLeft"
          overlayClassName={classes.etdTooltip}
        >
          <Icon
            type="info-circle"
            style={{ color: '#595959', margin: '3px 6px 0 3px' }}
            theme="filled"
          />
        </Tooltip>
      </span>
    );
  };

  const getMovementTypeValue = (movementType, origin, destination) : React.ReactElement => {
    switch (movementType) {
      case 'Port to Door': return renderMovementTypeValue('POD To Door Movement', destination?.movementType);
      case 'Door to Port': return renderMovementTypeValue('Door To POL Movement', origin?.movementType);
      case 'Door to Door': return (
        <React.Fragment>
          {renderMovementTypeValue('Door To POL Movement', origin?.movementType)}
          {renderMovementTypeValue('POD To Door Movement', destination?.movementType)}
        </React.Fragment>
      )
      default: return <div></div>;
    };
  };

  const renderMovementTypeValue = (label, value) : React.ReactElement => {
    return (
      <div style={{ marginBottom: '3px', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
        <span style={{ marginRight: '8px', fontWeight: 'normal' }}>{label}</span>{prettifyString(value)}
      </div>
    );
  };

  const renderMovementType = (origin, destination) : React.ReactElement => {
    const movementTypeForCarrier = getPrefillingObject()?.movementTypeForCarrier;
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>Movement Type For Carrier</Col>
        <Col span={18} className={classes.shipmentValue}>
          <React.Fragment>
            {movementTypeForCarrier || 'Port to Port'}
            <div style={{ marginTop: '6px' }}>
              {getMovementTypeValue(movementTypeForCarrier, origin, destination)}
            </div>
          </React.Fragment>
        </Col>
      </Row>
    );
  };

  const showMovementFields = (arrayList) => {
    const movementTypeForCarrier = getPrefillingObject()?.movementTypeForCarrier;
    return movementTypeForCarrier && arrayList.includes(movementTypeForCarrier);
  }

  const renderAddress = () : React.ReactElement => {
    const showOriginAddress = showMovementFields(['Door to Port', 'Door to Door']);
    const showDestinationAddress = showMovementFields(['Port to Door', 'Door to Door']);
    return (
      <React.Fragment>
        {showOriginAddress &&
          <Row style={{ marginBottom: '24px' }}>
          <Col span={6} className={classes.shipmentLabel}>Origin Address</Col>
          <Col span={18} className={classes.shipmentValue}>
            {bookingDetails?.origin?.address}
          </Col>
        </Row>
        }
        {showDestinationAddress &&
          <Row style={{ marginBottom: '24px' }}>
          <Col span={6} className={classes.shipmentLabel}>Destination Address</Col>
          <Col span={18} className={classes.shipmentValue}>
            {bookingDetails?.destination?.address}
          </Col>
        </Row>
        }
      </React.Fragment>
    );
  };

  const renderProductDetails = () : React.ReactElement => {
    const productObj = getPrefillingObject()?.productDetails || bookingDetails?.product;
    const hsCode = productObj?.hsCode;
    const productName = productObj?.name || productObj?.internalName;
    return (
      <Row style={{ marginBottom: '24px' }}>
        <Col span={6} className={classes.shipmentLabel}>Product Details</Col>
        <Col span={18} className={classes.shipmentValue}>
          {`${hsCode} | ${productName}`}
        </Col>
      </Row>
    );
  };

  const renderShipmentDetails = () : React.ReactElement => {
    const portOfLoading = getPrefillingObject()?.portOfLoading || chargeDetails?.portOfLoading;
    const portOfDischarge = getPrefillingObject()?.portOfDischarge || chargeDetails?.portOfDischarge;
    return (
      <div>
        {renderBasicShipmentDetail('Mode', bookingDetails?.mode)}
        {renderBasicShipmentDetail('Shipping Line', chargeDetails?.carrierDetails?.name)}
        {renderPortDetail(
          'Origin',
          `${bookingDetails?.originPortDetails?.name} [${bookingDetails?.originPortDetails?.code}]`,
          bookingDetails?.originPortDetails?.type === 'DRY' ?
            prettifyString(bookingDetails?.origin?.haulage) : undefined,
        )}
        {renderPortDetail(
          'POL',
          `${portOfLoading?.name} [${portOfLoading?.code}]`,
        )}
        {renderPortDetail(
          'Destination',
          `${bookingDetails?.destinationPortDetails?.name} [${bookingDetails?.destinationPortDetails?.code}]`,
          bookingDetails?.destinationPortDetails?.type === 'DRY' ?
            prettifyString(bookingDetails?.destination?.haulage) : undefined,
        )}
        {renderPortDetail(
          'POD',
          `${portOfDischarge?.name} [${portOfDischarge?.code}]`,
        )}
        {renderCargoProduct(
          prettifyString(bookingDetails?.cargoType),
          bookingDetails?.productType,
        )}
        {renderProductDetails()}
        {renderContainerDetails(getPrefillingObject()?.containerDetails)}
        {renderBasicShipmentDetail(
          renderETALabel(),
          getDateValue(
            inttraBookingDetails?.preferredSailingStartdate ||
            inttraBookingDetails?.estimatedTimeOfDeparture ||
            bookingDetails?.preferredSailingStartdate
          )?.format('DD MMM, YYYY'),
        )}
        {renderMovementType(
          bookingDetails?.origin,
          bookingDetails?.destination,
        )}
        {renderAddress()}
      </div>
    );
  };

  const renderAdditionalDetailsField = (
    label : React.ReactNode,
    key : string,
    placeholder : string,
    rules : any = [],
    initialValue? : string,
    keysToBeDisabled?: string,
  ) : React.ReactElement => {
    const disabled = (keysToBeDisabled === 'imoClassCode');
    return (
      <Row style={{ padding: '0 24px 8px 24px' }}>
        <Col span={5} className={classes.additonalDetailLabel} style={{ marginTop: '10px' }}>
          {label}
        </Col>
        <Col span={19}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator(key, {
              initialValue,
              rules: [ ...rules ],
            })(
              <Input
                style={{ width: '242px' }}
                disabled={disabled}
                placeholder={placeholder}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderTemperature = () : React.ReactElement => {
    const productMaster = cargoList?.find((cargo) => (
      cargo.label.product === bookingDetails?.productType
    ));
    const product = productMaster?.key.product;
    const min = product ? reeferProductTempRange[product]?.min : undefined;
    const max = product ? reeferProductTempRange[product]?.max : undefined;
    const details = getPrefillingObject();
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Temperature*</Col>
        <Col span={19} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item style={{ marginBottom: 0, display: 'inline-block', width: '20%' }}>
            {getFieldDecorator('productAdditionalDetails.temperatureControlled', {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (!isValidNumber(value)) {
                      cb('Required');
                    } else if (value > max) {
                      cb(`Maximum ${max} allowed`);
                    } else if (value < min) {
                      cb(`Minimum ${min} required`);
                    } else cb();
                  },
                },
              ],
              initialValue: details?.productAdditionalDetails?.temperatureControlled,
            })(
              <InputNumber
                type="number"
                style={{ width: '90%' }}
                placeholder="Temperature"
              />
            )}
          </Form.Item>
          <span>°<span style={{ fontWeight: 600 }}>C</span></span>
        </Col>
      </Row>
    );
  };

  const renderRelativeHumidity = () : React.ReactElement => {
    const details = getPrefillingObject();
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Relative Humidity*</Col>
        <Col span={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item style={{ marginBottom: 0, display: 'inline-block', width: '21%' }}>
            {getFieldDecorator('productAdditionalDetails.relativeHumidity', {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (!isValidNumber(value)) {
                      cb('Required');
                    } else if (value < 0) {
                      cb('Must be positive');
                    } else cb();
                  },
                },
              ],
              initialValue: details?.productAdditionalDetails?.relativeHumidity,
            })(
              <InputNumber
                type="number"
                style={{ width: '100%' }}
                precision={2}
                placeholder="Relative Humidity"
              /> 
            )}
          </Form.Item>
          <span style={{ marginLeft: '15px' }}><span style={{ fontWeight: 600 }}>%</span></span>
        </Col>
      </Row>
    );
  };

  const getPrefillingObject = () => {
    return (isAmend || isCreateNew) ? inttraBookingDetails : bookingDetails;
  }

  const renderVentDetails = () : React.ReactElement => {
    const details = getPrefillingObject();
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Vent Details*</Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0, marginRight: '4px' }}>
            {getFieldDecorator('productAdditionalDetails.ventSetting', {
              rules: [{ required: true, message: 'Required' }],
              initialValue: details?.productAdditionalDetails?.ventSetting,
            })(
              <Radio.Group>
                <Radio style={{ marginRight: '16px' }} value="Open">
                  Open
                </Radio>
                <Radio value="Closed">
                  Closed
                </Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderAdditionalReeferDetails = () : React.ReactElement => {
    return (
      <div>
        <div className={classes.additionalDetailsCargo} style={{ padding: '0 24px' }}>
          Reefer Product Details
        </div>
        <div style={{ marginLeft: '10px' }}>
          {renderTemperature()}
          {renderRelativeHumidity()}
          {renderVentDetails()}
        </div>
      </div>
    );
  };

  const getHazFields = () => {
    const details = getPrefillingObject();
    return ({
      shippingName: {
        key: 'productAdditionalDetails.shippingName',
        label: 'Shipping Name*',
        rules: [
          { required: true, message: 'Required' },
          { max: 512, message: 'Maximum 512 characters allowed' }
        ],
        placeholder: 'Enter Shipping Name',
        initialValue: details?.productAdditionalDetails?.shippingName ||
          details?.product?.internalName || details?.productType,
      },
      imoClassCode: {
        key: 'productAdditionalDetails.imoClassCode',
        label: 'IMO Class*',
        rules: [
          { required: true, message: 'Required' },
          { max: 7, message: 'Maximum 7 characters allowed' }
        ],
        placeholder: 'Enter IMO Class',
        initialValue: productIMOClassCodeMap[bookingDetails?.productType],
      },
      undgNumber: {
        key: 'productAdditionalDetails.undgNumber',
        label: 'UNDG Number*',
        rules: [
          { required: true, message: 'Required' },
          { max: 4, message: 'Must contain 4 characters' },
          { min: 4, message: 'Must contain 4 characters' },
        ],
        placeholder: 'Enter UNDG Number*',
        initialValue: details?.productAdditionalDetails?.undgNumber,
      },
      emergencyContactName: {
        key: 'productAdditionalDetails.emergencyContactName',
        label: 'Emergency Contact Name*',
        rules: [
          { required: true, message: 'Required' },
        ],
        placeholder: 'Enter Name',
        initialValue: details?.productAdditionalDetails?.emergencyContactName,
      },
      emergencyContactNumber: {
        key: 'productAdditionalDetails.emergencyContactNumber',
        label: 'Emergency Contact Number*',
        rules: [
          { required: true, message: 'Required' },
          { max: 512, message: 'Maximum 512 characters allowed' },
        ],
        placeholder: 'Enter Number',
        initialValue: details?.productAdditionalDetails?.emergencyContactNumber,
      },
      emsNumber: {
        key: 'productAdditionalDetails.emsNumber',
        label: 'EMS Number',
        rules: [
          { max: 6, message: 'Maximum 6 characters allowed' },
        ],
        placeholder: 'Enter EMS Number',
        initialValue: details?.productAdditionalDetails?.emsNumber,
      },
    });
  };

  const renderAdditionalHazDetails = () : React.ReactElement => {
    const hazFields = getHazFields();
    return (
      <div>
        <div className={classes.additionalDetailsCargo} style={{ padding: '0 24px' }}>
          Haz Product Details
        </div>
        <div style={{ marginLeft: '10px' }}>
          {Object.keys(hazFields).map(key => (
            renderAdditionalDetailsField(
              hazFields[key].label,
              hazFields[key].key,
              hazFields[key].placeholder,
              hazFields[key].rules,
              hazFields[key].initialValue,
              key,
            )
          ))}
          {renderPackingGroup()}
          {renderflashPointTemp()}
        </div>
      </div>
    );
  };

  const renderPackingGroup = () => {
    const details = getPrefillingObject();
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Packing Group</Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('productAdditionalDetails.packingGroup', {
              initialValue: details?.productAdditionalDetails?.packingGroup,
            })(
              <Select
                getPopupContainer={(trigger: any) => trigger.parentNode}
                allowClear
                style={{ width: '215px' }}
                placeholder="Select Packing Group"
              >
                {packingGroups?.map(item => (
                  <Select.Option key={item.label}>{item.label}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderflashPointTemp = () => {
    const details = getPrefillingObject();
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Flash Point Temp</Col>
        <Col span={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item style={{ marginBottom: 0, marginRight: '4px', display: 'inline-block', width: '20%' }}>
            {getFieldDecorator('productAdditionalDetails.flashPointTemp', {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (value >= 1000) {
                      cb('Must be less than 1000');
                    } else cb();
                  },
                },
              ],
              initialValue: details?.productAdditionalDetails?.flashPointTemp,
            })(
              <InputNumber
                type="number"
                style={{ width: '100%' }}
                precision={2}
                placeholder="0.00"
              /> 
            )}
          </Form.Item>
          <span>°<span style={{ fontWeight: 600 }}>C</span></span>
        </Col>
      </Row>
    );
  };

  const renderAmendmentRemarks = () : React.ReactElement => {
    return (
      <Row
        className={classes.additionalDetailsField}
        style={{ alignItems: 'unset', paddingTop: '8px' }}
        id="amendmentJustification"
      >
        <Col span={5} className={classes.additonalDetailLabel}>Amendment Remarks*</Col>
        <Col span={19}>
          <Form.Item style={{ marginBottom: 5 }}>
            {getFieldDecorator('amendmentJustification', {
              rules: [{ required: true, message: 'Required' }],
              initialValue: inttraBookingDetails?.amendmentJustification,
            })(
              <TextArea
                style={{ width: '80%' }}
                placeholder="Add Amendment Remarks"
                rows={3}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const renderPartySelection =  (index, initialValue?) : React.ReactElement => {
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`partiesInvolved[${index}].type`, {
          rules: [{
            required: form.getFieldValue(`partiesInvolved[${index}].name`) ||
              form.getFieldValue(`partiesInvolved[${index}].address`),
            message: 'Required',
          }],
          initialValue,
        })(
          <Select
            className={classes.paymentSelect}
            showSearch
            getPopupContainer={(trigger: any) => trigger.parentNode}
            allowClear
            placeholder={`Select Type`}
            dropdownMatchSelectWidth={false}
            optionFilterProp="children"
            onChange={() => {
              form.setFieldsValue({ [`partiesInvolved[${index}].address`]: undefined })
            }}
          >
            {Object.keys(stakeHolders || {})?.map(key => (
              <Select.Option key={key}>
                {startCase(key)}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    );
  };

  const renderPartyName =  (index, initialValue?) : React.ReactElement => {
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`partiesInvolved[${index}].name`, {
          rules: [{
            validator: (rule, value, cb) => {
              if (!value && (form.getFieldValue(`partiesInvolved[${index}].type`) ||
                form.getFieldValue(`partiesInvolved[${index}].address`))) {
                cb('Required');
              } else if (value?.length > 70) {
                cb('Maximum 70 characters allowed');
              } else cb();
            },
          }],
          initialValue,
        })(
          <Input
            className={classes.paymentName}
            placeholder="Enter Name"
          />
        )}
      </Form.Item>
    );
  };

  const getEditAddressData = (index) => {
    const party = form.getFieldValue(`partiesInvolved[${index}]`);
    const addressData = addressList &&
      addressList[party?.type]?.find(item => item.id === party?.address?.key);
    return addressData;
  };

  const renderPartyAddress = (index) : React.ReactElement => {
    const partyType = form.getFieldValue(`partiesInvolved[${index}].type`);
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {form.getFieldDecorator(`partiesInvolved[${index}].address`, {
          rules: [{
            required: form.getFieldValue(`partiesInvolved[${index}].type`) ||
              form.getFieldValue(`partiesInvolved[${index}].name`),
            message: 'Required',
          }],
          initialValue: partiesInvolved?.[index]?.address,
        })(
          <Select
            className={classNames(classes.selectField, classes.suffixIcon)}
            dropdownMatchSelectWidth={false}
            getPopupContainer={(trigger: any) => trigger.parentNode}
            showSearch
            allowClear
            labelInValue
            showArrow
            optionFilterProp="children"
            placeholder="Select Address"
            suffixIcon={
              <Icon
                type="edit"
                onClick={() => setState({
                  isAddEditAddressModalVisible: true,
                  editAddressData: getEditAddressData(index),
                })}
                theme="filled"
              />
            }
            onFocus={() => {
              if (!isValidString(partyType)) {
                message.error('Please select Party Type');
                return;
              }
              getAddressList(index);
              setState({ selectedPartyType: partyType });
            }}
            dropdownRender={menu => {
              if (addressList && isValidArray(addressList[partyType]) || isFetchingAddress) {
                return renderAddressDropdown(menu);
              } else {
                return <div></div>;
              }
            }}
          >
            {addressList && addressList[partyType]?.map(item => (
              <Select.Option key={item.id}>{getSIPartyAddress(item)}</Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    );
  };

  const renderAddEditPartyAddress = () : React.ReactElement =>{
    return (
      <UploadSINotifyPartiesAddAddress
        isVisible={isAddEditAddressModalVisible}
        onCancel={() => {
          setState({
            isAddEditAddressModalVisible: false,
            editAddressData: undefined,
          })
        }}
        onSubmit={() => {
          getAddressList(0, true);
          setState({
            isAddEditAddressModalVisible: false,
            editAddressData: undefined,
          })
        }}
        editAddressData={editAddressData}
        // shipmentId={shipmentData?.id}
        partyType={selectedPartyType}
      />
    );
  };

  const getAddressList = async (index?, callApi?) : Promise<void> => {
    const partyType = form.getFieldValue(`partiesInvolved[${index}].type`);
    if (!addressList || callApi) {
      setState({ isFetchingAddress: true });
      const response = await fetchShipmentInstructionsPartiesAddress();
      if (response.isSuccess) {
        setState({ isFetchingAddress: false, addressList: response?.data || [] });
        if (!isValidArray(response?.data && response.data[partyType]) && !callApi ) {
          setState({ isAddEditAddressModalVisible: true });
        }
      } else {
        message.error(response.errorMessage);
        setState({ isFetchingAddress: false });
      }
    } else if (!isValidArray(addressList[partyType])) {
      setState({ isAddEditAddressModalVisible: true });
    }
  };

  const renderAddressDropdown = (menu: React.ReactNode) => {
    if (isFetchingAddress) return <Spin style={{ marginLeft: '45%' }} />;
    return <React.Fragment>
      {menu}
      <div
        className={classes.createAddressStyle}
        onMouseDown={e => stops(e)}
        onClick={() => setState({ isAddEditAddressModalVisible: true })}>
        + Add Address
      </div>
    </React.Fragment>;
  };

  const renderPartiesInvolved = () : React.ReactElement => {
    return (
      <div style={{ padding: '0 24px' }}>
        <div className={classes.additionalDetailsCargo}>
          Parties Involved {chargeDetails?.carrierDetails?.id === 'CMACGM' ? <Asterisk /> : null}
        </div>
        <Row>
          <div>
            <Row style={{ fontSize: `${tokens.fontSize.small}px`, marginBottom: '8px', fontWeight: 600 }}>
              <Col span={4}>
                Party
              </Col>
              <Col span={6}>
                Name
              </Col>
              <Col span={10}>
                Address
              </Col>
              <Col span={3} />
            </Row>
          </div>
          {partiesInvolved?.map((item, index) => (
            <Row className={classes.paymentDetails} key={index}>
              <Col span={4}>
                {renderPartySelection(
                  index,
                  partiesInvolved?.[index]?.type,
                )}
              </Col>
              <Col span={6}>
                {renderPartyName(
                  index,
                  partiesInvolved?.[index]?.name,
                )}
              </Col>
              <Col span={10}>
                {renderPartyAddress(index)}
              </Col>
              <Col span={1}>
                {(partiesInvolved?.length > 1 && index >= 1) &&
                  <Icon type="close"
                    style={{ color: 'red', margin: '12px 0 0 6px' }}
                    onClick={() => handleRemove(index, 'partiesInvolved')}
                  />}
              </Col>
            </Row>
          ))}
          <div>
            <a
              className={classes.addMore}
              onClick={() => handleAddMore('partiesInvolved', partiesInvolved)}
            >
              + Add More
            </a>
          </div>
        </Row>
      </div>
    );
  };

  const renderAdditionalDetails = () : React.ReactElement => {
    return (
      <div style={{ marginTop: '24px' }}>
        {(isAmend && !isRetryInttraRequest) && renderAmendmentRemarks()}
        {renderAdditionalDetailsField(
          'Contract Number',
          'contractNumber',
          'Contract Number',
          [{ max: 35, message: 'Maximum 35 characters allowed' }],
          inttraBookingDetails?.contractNumber,
        )}
        {chargeDetails?.carrierDetails?.id === 'CMACGM' && renderAdditionalDetailsField(
          <>Agreement Reference<Asterisk /></>,
          'agreementReference',
          'Agreement Reference',
          [{ required: true, message: 'Required' }],
          inttraBookingDetails?.agreementReference,
        )}
        {renderBookingOffice()}
        {bookingDetails.cargoType === CargoType.REEFER && renderAdditionalReeferDetails() }
        {bookingDetails.cargoType === CargoType.HAZ && renderAdditionalHazDetails()}
        {renderPaymentDetails()}
        {chargeDetails?.carrierDetails?.id === 'CMACGM' && renderPartiesInvolved()}
        {renderNotifyUsers()}
        {receiveInttraBookingNoteEmail && renderEmailForBookingNoteSelection()}
        {renderRemark()}
      </div>
    );
  };

  const fetchBookingOffice = async (queryString) => {
    setState({ isBookingOfficeLoading: true });
    let bookingOffice = [];
    const response = await fetchLocation({ queryString });
    if (response.isSuccess) {
      bookingOffice = response.data || [];
    } else {
      message.error(response.errorMessage);
    }
    setState({
      bookingOffice,
      isBookingOfficeLoading: false,
    });
  };

  const renderBookingOffice = () => {
    const bookingOfficeObj = inttraBookingDetails?.bookingOffice;
    return (
      <Row className={classes.additionalDetailsField}>
        <Col span={5} className={classes.additonalDetailLabel}>Booking Office</Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('bookingOffice', {
              initialValue: !isEmpty(bookingOfficeObj) ? {
                key: bookingOfficeObj.id,
                label: `${bookingOfficeObj.name} (${bookingOfficeObj.code})`,
              } : undefined,
            })(
              <Select
                getPopupContainer={(trigger: any) => trigger.parentNode}
                allowClear
                labelInValue
                showSearch
                onFocus={() => setState({ searchTerm: '' })}
                onSearch={(searchTerm) => setState({ searchTerm })}
                style={{ width: '242px' }}
                placeholder="Search Booking Office"
                filterOption={(inputValue, option) => true}
                dropdownRender={menu => renderSelectDropDown(menu, isBookingOfficeLoading)}
              >
                {bookingOffice?.map(item => (
                  <Select.Option key={item.id}>{`${item.name} (${item.code})`}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  const onChangePaymentField = (option, index, key) => {
    setState({
      paymentFieldIndex: index,
      paymentFieldChanged: !paymentFieldChanged,
    });
    if (key === 'payer') {
      if (option === 'Shipper') {
        form.setFieldsValue({ [`paymentDetails[${index}].name`]: bookingData?.shipperName })
      } else if (option === 'Forwarder') {
          form.setFieldsValue({ [`paymentDetails[${index}].name`]: bookingData?.ffName })
      } else if (option === 'Consignee' || !option) {
        form.setFieldsValue({ [`paymentDetails[${index}].name`]: undefined })
      }
    }
  };

  const isPaymentOrUserFieldMandatory = (index, key) => {
    const arrayList = isValidArray(form.getFieldValue(key))
      ? form.getFieldValue(key) : [{}];
    return isValidArray(arrayList) && arrayList[index] &&
      Object.values(arrayList[index])?.some(value => isValidString(value));
  };

  const isValuePresent = (key) => {
    const arrayList = isValidArray(form.getFieldValue(key))
      ? form.getFieldValue(key) : [{}];
    return arrayList?.some(item => !isEmpty(item) &&
      Object.values(item)?.some(value => isValidString(value)));
  };

  const renderPaymentFields =  (value, index, key, arrayList, initialValue?) : React.ReactElement => {
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`paymentDetails[${index}].${key}`, {
          rules: [{
            validator: (rule, value, cb) => {
              if (!value && isPaymentOrUserFieldMandatory(index, 'paymentDetails')) {
                cb('Required');
              } else cb();
            },
          }],
          initialValue,
        })(
          <Select
            getPopupContainer={(trigger: any) => trigger.parentNode}
            allowClear
            className={classes.paymentSelect}
            placeholder={`Select ${value}`}
            dropdownMatchSelectWidth={false}
            showSearch
            onChange={(option) => {
              onChangePaymentField(option, index, key)
            }}
          >
            {arrayList?.map(item => (
              <Select.Option key={item.key}>{item.label}</Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    );
  };

  const renderPaymentNameField =  (index) : React.ReactElement => {
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`paymentDetails[${index}].name`, {
          rules: [{
            validator: (rule, value, cb) => {
              if (!value && isPaymentOrUserFieldMandatory(index, 'paymentDetails')) {
                cb('Required');
              } else cb();
            },
          }],
          initialValue: getInitialPaymentAndUserValue(index, 'name', paymentDetails),
        })(
          <Input
            className={classes.paymentName}
            placeholder="Name"
            onChange={() => {
              setState({
                paymentFieldIndex: index,
                paymentFieldChanged: !paymentFieldChanged,
              });
            }}
          />
        )}
      </Form.Item>
    );
  };

  const handleAddMore = (label, list) => {
    const newList = [
      ...list,
      {},
    ];
    setState({ [`${label}`]: newList });
  };

  const handleRemove = (index, label) => {
    const newList = form.getFieldValue(label);
    newList.splice(index, 1);
    setState({ [`${label}`]: newList });
    form.setFieldsValue({
      [`${label}`]: newList,
    });
  };

  const getInitialPaymentAndUserValue = (index, key, state) => {
    if ((!isEmpty(state) && state[index])) {
      return state[index][key];
    }
    return undefined;
  };

  const renderPaymentDetails = () : React.ReactElement => {
    const isMandatory = isValuePresent('paymentDetails');
    return (
      <div style={{ padding: '0 24px' }}>
        <div className={classes.additionalDetailsCargo}>
          Payment Details
        </div>
        <div>
          <Row style={{ fontSize: `${tokens.fontSize.small}px`, marginBottom: '8px', fontWeight: 600 }}>
            <Col span={6}>
              Charge Type{isMandatory && <Asterisk />}
            </Col>
            <Col span={6}>
              Freight Terms{isMandatory && <Asterisk />}
            </Col>
            <Col span={5}>
              Payer{isMandatory && <Asterisk />}
            </Col>
            <Col span={6} />
          </Row>
        </div>
        <div>
          {paymentDetails?.map((item, index) => (
            <Row className={classes.paymentDetails} key={index}>
              <Col span={6}>
                {renderPaymentFields(
                  'Charge Type',
                  index,
                  'chargeType',
                  chargeTypes,
                  getInitialPaymentAndUserValue(index, 'chargeType', paymentDetails),
                )}
              </Col>
              <Col span={6}>
                {renderPaymentFields(
                  'Freight Terms',
                  index,
                  'freightTerms',
                  freightTerms,
                  getInitialPaymentAndUserValue(index, 'freightTerms', paymentDetails),
                )}
              </Col>
              <Col span={5}>
                {renderPaymentFields(
                  'Payer',
                  index,
                  'payer',
                  payer,
                  getInitialPaymentAndUserValue(index, 'payer', paymentDetails),
                )}
              </Col>
              <Col span={6}>
                {renderPaymentNameField(index)}
              </Col>
              <Col span={1}>
                {(paymentDetails?.length !== 1 && index !== paymentDetails?.length - 1) && <Icon type="close"
                  style={{ color: 'red', marginTop: '12px' }}
                  onClick={() => handleRemove(index, 'paymentDetails')}
                />}
              </Col>
            </Row>
          ))}
          <div
            className={classes.addMore}
            onClick={() => handleAddMore('paymentDetails', paymentDetails)}
          >+ Add More</div>
        </div>
      </div>
    );
  };

  const handleUserChange = (index) => {
    setState({
      userFieldIndex: index,
      userFieldChanged: !userFieldChanged,
    });
  };

  const renderNotifyUsersField =  (index, key, label, initialValue?) : React.ReactElement => {
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`notifyUsers[${index}].${key}`, {
            rules: [
              {
                validator: (rule, value, cb) => {
                  if (!value && isPaymentOrUserFieldMandatory(index, 'notifyUsers')) {
                    cb('Required');
                  } else cb();
                },
              },
              ...((key === 'email') ? [{
              type: 'email', message: 'Please enter a valid Email Id',
              }] : []),
            ],
            initialValue,
        })(
          <Input
            className={classes.paymentName}
            placeholder={label}
            onChange={() => handleUserChange(index)}
          />
        )}
      </Form.Item>
    );
  };

  const renderNotifyUsers = () : React.ReactElement => {
    const isMandatory = isValuePresent('notifyUsers');
    return (
      <div style={{ padding: '0 24px' }}>
        <div className={classes.additionalDetailsCargo}>
          Notify Users
          <Tooltip
            overlayStyle={{ fontSize: `${tokens.fontSize.small}px` }}
            title="Add users for INTTRA notifications regarding the status and updates of this booking"
          >
            <Icon
              type="info-circle"
              style={{ color: '#595959', margin: '3px 0 0 6px' }}
              theme="filled"
            />
          </Tooltip>
        </div>
        <div>
          <Row style={{ fontSize: `${tokens.fontSize.small}px`, marginBottom: '8px', fontWeight: 600 }}>
            <Col span={2} style={{ textAlign: 'center' }}>
              S.N.
            </Col>
            <Col span={5}>
              Name{isMandatory && <Asterisk />}
            </Col>
            <Col span={8}>
              Email ID{isMandatory && <Asterisk />}
            </Col>
            <Col span={1} />
          </Row>
        </div>
        <div>
          {notifyUsers?.map((item, index) => (
            <Row className={classes.paymentDetails} key={index}>
              <Col span={2} style={{ fontWeight: tokens.fontWeight.semibold, textAlign: 'center', marginTop: '10px' }}>
                {index + 1}
              </Col>
              <Col span={5}>
                {renderNotifyUsersField(
                  index,
                  'name',
                  'Name',
                  getInitialPaymentAndUserValue(index, 'name', notifyUsers),
                )}
              </Col>
              <Col span={8}>
                {renderNotifyUsersField(
                  index,
                  'email',
                  'Email',
                  getInitialPaymentAndUserValue(index, 'email', notifyUsers),
                )}
              </Col>
              <Col span={1}>
                {(notifyUsers?.length !== 1 && index !== notifyUsers?.length - 1) &&
                  <Icon type="close"
                    style={{ color: 'red', marginTop: '12px' }}
                    onClick={() => handleRemove(index, 'notifyUsers')}
                  />
                }
              </Col>
            </Row>
          ))}
          {!(chargeDetails?.carrierDetails?.id === 'COSCO' && notifyUsers?.length === 2) && <div
            style={{ marginLeft: '16px' }}
            className={classes.addMore}
            onClick={() => handleAddMore('notifyUsers', notifyUsers)}
          >+ Add More</div>}
        </div>
      </div>
    );
  };

  const fetchAllUsers = async () : Promise<void> => {
    setState({ isFetchingUsers: true });
    let usersList = [];
    const response = await fetchAllUsersOfCurrentOrg();
    if (response.isSuccess) {
      usersList = response.data ? response.data.map(item => ({
          id: item.id,
          label: item.email,
          status: item.status,
        })) : []
    } else {
      message.error(response.errorMessage)
    }
    setState({ usersList, isFetchingUsers: false });
  };

  const renderFooter = () : React.ReactElement => {
    return (
      <div className={classes.footer}>
        <a style={{
          color: tokens.colors.primary,
          fontSize: `${tokens.fontSize.h3}px`,
          cursor: isLoading ? 'not-allowed' : 'pointer',
        }}
          onClick={() => {
            !isLoading && handlePrevious()
          }}>Previous</a>
        <Button
          loading={isLoading}
          type="primary"
          style={{ backgroundColor: tokens.colors.primary, border: tokens.colors.primary, marginRight: '70px' }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    );
  };

  const getEdittedValues = (newValues) => {
    if (isAmend || isCreateNew) {
      setState({
        inttraBookingDetails: {
          ...inttraBookingDetails,
          ...newValues,
        },
      });
    } else {
      setState({
        bookingDetails: {
          ...bookingDetails,
          ...newValues,
        },
      });
    }
  };

  const getPaymentAndUserValues = (arrayList) => {
    return arrayList?.filter(item => !isEmpty(item) &&
      Object.values(item)?.some(value => isValidString(value)));
  };

  const createInttraBookingAPIBody = (formValues) => {
    const showOriginAddress = showMovementFields(['Door to Port', 'Door to Door']);
    const showDestinationAddress = showMovementFields(['Port to Door', 'Door to Door']);
    const {
      mode,
      origin,
      destination,
      type,
      product,
      cargoType,
      productType,
      containerDetails,
      movementTypeForCarrier,
      preferredSailingStartdate,
      estimatedTimeOfDeparture,
      productDetails,
      portOfLoading,
      portOfDischarge,
    } = getPrefillingObject();

    const etd = preferredSailingStartdate || estimatedTimeOfDeparture;

    const {
      contractNumber,
      bookingOffice,
      productAdditionalDetails,
      paymentDetails,
      notifyUsers,
      bookingNoteToBeDeliveredEmail,
      remarks,
      agreementReference,
    } = formValues;

    let originObj = {
      ...origin,
      preferredWetPort: portOfLoading?.code || chargeDetails?.portOfLoading?.code,
    }

    if (!showOriginAddress) {
      delete originObj?.address;
    }

    let destinationObj = {
      ...destination,
      preferredWetPort: portOfDischarge?.code || chargeDetails?.portOfDischarge?.code,
    }

    if (!showDestinationAddress) {
      delete destinationObj?.address;
    }

    let partiesInvolved: StakeHolders[] = [];
    formValues.partiesInvolved?.forEach((item) => {
      if (isValidString(item.type) && (isValidString(item.name))) {
        partiesInvolved.push({
          ...item,
          type: item.type,
          address: item.address?.key,
        });
      }
    });

    return ({
      mode,
      type,
      cargoType,
      productType,
      containerDetails,
      contractNumber,
      remarks,
      inttraCode,
      bookingId,
      agreementReference,
      bookingOfficeId: bookingOffice?.key,
      movementTypeForCarrier: movementTypeForCarrier || 'Port to Port',
      carrierCode: chargeDetails.ffCarrier,
      productDetails: productDetails || {
        name: product?.internalName,
        hsCode: product?.hsCode
      },
      origin: {
        ...originObj,
      },
      destination: {
        ...destinationObj,
      },
      estimatedTimeOfDeparture: {
        dateString: getDateValue(etd)?.format('YYYY-MM-DD'),
        time: getDateValue(etd)?.format('HH:mm'),
      },
      bookingNoteToBeDeliveredEmail: bookingNoteToBeDeliveredEmail?.label,
      ...((cargoType === 'REEFER' || cargoType === 'HAZ') && {
        productAdditionalDetails,
      }),
      ...(isValuePresent('paymentDetails') && {
        paymentDetails: getPaymentAndUserValues(paymentDetails),
      }),
      ...(isValuePresent('notifyUsers') && {
        notifyUsers: getPaymentAndUserValues(notifyUsers),
      }),
      ...((isAmend && !isRetryInttraRequest) && {
        amendmentJustification: formValues.amendmentJustification,
      }),
      partiesInvolved,
    });
  };

  const handleSubmit = () : void => {
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      if (getPrefillingObject()?.containerDetails?.some(item => !isValidNumber(item.weight?.value))) {
        message.error('Cargo Weight is mandatory! Please edit shipment to update.');
        return;
      }
      if (isValuePresent('notifyUsers')) {
        const notifyUsersList = getPaymentAndUserValues(values?.notifyUsers);
        const uniqueNotifyUsersList = uniqBy(notifyUsersList, 'email');
        if (uniqueNotifyUsersList?.length !== notifyUsersList?.length) {
          message.error('Email Ids of Users for INTTRA notifications must be unique');
          return;
        }
      }
      if (chargeDetails?.carrierDetails?.id === 'CMACGM' && !isValuePresent('partiesInvolved')) {
        message.error('At least one Party is required');
        return;
      }
      if (getPaymentAndUserValues(values.paymentDetails)) {
        let payerErrors : string [] = [];
        let payers : Payers = {
          Consignee: [],
          Shipper: [],
          FF: [],
        };
        getPaymentAndUserValues(values.paymentDetails).forEach(item => {
          if (item.payer === 'Consignee') {
            payers.Consignee.push(item.name)
          } else if (item.payer === 'Shipper') {
            payers.Shipper.push(item.name);
          } else if (item.payer === 'Forwarder') {
            payers.FF.push(item.name);
          }
        });
        Object.keys(payers)?.forEach(key => {
          if (isValidArray(payers[key]) && uniqArray(payers[key]).length !== 1) {
            payerErrors.push(`${key} party name cannot be different under different charge headers`);
          }
        });
        if (isValidArray(payerErrors)) {
          message.error(payerErrors.join(', '), 5);
          return;
        }
      }

      const body = createInttraBookingAPIBody(values);
      setState({ isLoading: true });
      isBooking(true);
      const response = (isAmend && !isRetryInttraRequest) ?
        await amendInttraBookingRequest(body) : await createInttraBooking(body);
      if (!response.isSuccess) {
        message.error(response.errorMessage);
        setState({ isLoading: false });
      } else {
        setState({ isLoading: false, isProtipVisible: true });
      }
      isBooking(false);
    });
  }

  const renderEmailForBookingNoteSelection = () : React.ReactElement => {
    const initialValue = (isAmend || isCreateNew) ?
      ({
        id: inttraBookingDetails?.bookingNoteToBeDeliveredName,
        label: inttraBookingDetails?.bookingNoteToBeDeliveredEmail,
      })
      :
      ({
        id: userData?.id, label: userData?.email,
      });
    return (
      <div style={{ padding: '0 24px' }}>
        <div className={classes.additionalDetailsCargo} style={{ marginBottom: '8px' }}>
          Select the email ID to which Booking Note will be delivered.
        </div>
        <div>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('bookingNoteToBeDeliveredEmail', {
              rules: [{ required: true, message: 'Required' }],
              initialValue
            })(
              <Select
                getPopupContainer={(trigger: any) => trigger.parentNode}
                style={{ width: '50%' }}
                labelInValue
                showSearch
                optionFilterProp="children"
                onFocus={() => fetchAllUsers()}
                dropdownRender={menu => renderSelectDropDown(menu, isFetchingUsers)}
              >
                {usersList?.map(item => item.status === 'ACTIVE' && (
                  <Select.Option key={item.id}>{item.label}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </div>
      </div>
    );
  };

  const getInitialRemarkValue = () => {
    const originPort = bookingDetails?.originPortDetails;
    const destinationPort = bookingDetails?.destinationPortDetails;
    const POL = bookingDetails?.portOfLoading?.name || chargeDetails?.portOfLoading?.name;
    const POD = bookingDetails?.portOfDischarge?.name || chargeDetails?.portOfDischarge?.name;
    const originHaulageRemark =
      `${originPort?.name} to ${POL} movement will be taken care by ${prettifyString(bookingDetails?.origin?.haulage)}`;
    const destinationHaulageRemark =
      `${destinationPort?.name} to ${POD} movement will be taken care by ${prettifyString(bookingDetails?.destination?.haulage)}`;
    if (isAmend || isCreateNew) {
      return inttraBookingDetails?.remarks;
    }
    if (originPort?.type === 'DRY' && destinationPort?.type === 'DRY') {
      return (
        `1. ${originHaulageRemark}\n2. ${destinationHaulageRemark}`
      );
    }
    if (originPort?.type === 'DRY') {
      return originHaulageRemark;
    }
    if (destinationPort?.type === 'DRY') {
      return destinationHaulageRemark;
    }
    return;
  }

  const renderRemark = () : React.ReactElement => {
    return (
      <Row style={{ marginTop: '24px', padding: '0 24px' }}>
        <Col span={3} style={{ fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}>Remark</Col>
        <Col span={17}>
        <Form.Item style={{ marginBottom: 0 }}>
          {getFieldDecorator('remarks', {
            initialValue: getInitialRemarkValue()
          })(
            <TextArea
              className={classes.paymentName}
              placeholder="Share additional details"
              rows={3}
            />
          )}
        </Form.Item>
        </Col>
      </Row>
    );
  };

  const handleProtipOkay = () => {
    reload();
    isRetryInttraRequest && handleCloseSideDrawer && handleCloseSideDrawer();
    setState({
      isProtipVisible: false,
    });
    handleCloseBookingModal();
  }

  const renderProtip = () : React.ReactElement => {
    const messageToShow = (isAmend && !isRetryInttraRequest) ?
    `Updated Booking details have been successfully sent to INTTRA.
    You will be notified with updates on Shipsy platform and over email after shipping line reviews the request.` :
    `Booking request has been successfully sent to INTTRA.
    You will be notified with updates on Shipsy platform and over email after shipping line reviews the request.`;
    return (
      <Protip
        visible={isProtipVisible}
        success={'Congrats'}
        message1={messageToShow}
        message2={'You can view this Booking in SL Response Awaited tab.'}
        okay={'Okay'}
        onOkay={handleProtipOkay}
        height={300}
      />
    );
  };

  const renderEditShipmentModal = () : React.ReactElement => {
    return (
      <EditINTTRAShipmentDetailsModal
        isVisible={isEditShipmentModalVisible}
        bookingDetails={getPrefillingObject()}
        chargeDetails={chargeDetails}
        onCancel={() => {
          setState({ isEditShipmentModalVisible: false });
        }}
        onSave={(newValues) => getEdittedValues(newValues)}
        isAmendOrNew={isAmend || isCreateNew}
      />
    );
  };

  const renderInttraErrors = () => {
    const inttraErrorReasons = bookingData.inttraErrorReasons;
    return (
      <div className={classes.inttraError}>
        <div style={{ fontWeight: 'bold', marginRight: '12px' }}>INTTRA Error message:</div>
        {getConditionalBullets(inttraErrorReasons)}
      </div>
    );
  }

  return (
    <React.Fragment>
      {isRetryInttraRequest && bookingData.inttraErrorReasons && renderInttraErrors()}
      <Row className={classes.parentDiv}>
        <Col span={10} className={classes.shipmentDetails}>
          <div className={classes.shipmentDetailsTitle}>
            <span>Shipment Details</span>
            <span
              className={classes.editShipment}
              style={{
                cursor: isLoading ? 'not-allowed' : 'pointer',
              }}
              onClick={() => {
                !isLoading && setState({ isEditShipmentModalVisible: true });
              }}
            >
              Edit
              <Icon type="edit" style={{ marginLeft: '8px' }} />
            </span>
          </div>
          {renderShipmentDetails()}
        </Col>
        <Col span={14} className={classes.additionalDetails}>
          <div className={classes.additionalDetailsTitle}>Additional Details</div>
          {renderAdditionalDetails()}
        </Col>
      </Row>
      {renderFooter()}
      {isProtipVisible && renderProtip()}
      {isEditShipmentModalVisible && renderEditShipmentModal()}
      {isAddEditAddressModalVisible && renderAddEditPartyAddress()}
    </React.Fragment>
  );
};

const mapStateToProps = ({ masterData, inquiryReducer }, ownProps) => ({
  containerList: masterData.containerList,
  cargoList: masterData.cargoList,
  userData: masterData.userData,
  bookingMasterData: masterData.bookingMasterData,
  reeferProductTempRange: inquiryReducer.masterData.reeferProductTempRange,
  packingGroups: inquiryReducer.masterData.packingGroups,
  receiveInttraBookingNoteEmail: masterData.modules.receive_inttra_booking_note_email,
  inttraCode: masterData.inttraCode,
  productIMOClassCodeMap: inquiryReducer.masterData.productIMOClassCodeMap,
  inttraBookingNotifyPartyTypes: masterData.bookingMasterData?.inttraBookingNotifyPartyTypes,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    reload: setPrevPagination(ownProps.type),
  }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(React.memo(
    (withStyles(INTTRABookingConfirmationModalStyles)(Form.create()(INTTRABookingConfirmationModal)))
  )
);
